import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: 'https://communitybotbyzwizai.herokuapp.com',
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const atomicboyApi = {
  countUserLevel: (chapter) => {
    return instance().get(`/countUserLevel?chapter=${chapter}`)
  },
  userListByLevel: (params) => {
    return instance().get('/userListByLevel', { params })
  },
  falseQuestionReport: (data) => {
    return instance().post('/falseQuestionReport', data)
  }
}
export default atomicboyApi



// WEBPACK FOOTER //
// ./src/api/atomicboy.js